var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningsvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "white",
    stroke: "#EDCF30",
    strokeWidth: 1.56522
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9997 11.8333C12.845 11.8333 12.6966 11.8948 12.5872 12.0042C12.4778 12.1136 12.4163 12.262 12.4163 12.4167V15.9167C12.4163 16.0714 12.4778 16.2197 12.5872 16.3291C12.6966 16.4385 12.845 16.5 12.9997 16.5C13.1544 16.5 13.3028 16.4385 13.4122 16.3291C13.5215 16.2197 13.583 16.0714 13.583 15.9167V12.4167C13.583 12.262 13.5215 12.1136 13.4122 12.0042C13.3028 11.8948 13.1544 11.8333 12.9997 11.8333ZM12.9997 9.5C12.8555 9.5 12.7145 9.54276 12.5946 9.62289C12.4747 9.70301 12.3812 9.81689 12.326 9.95013C12.2708 10.0834 12.2564 10.23 12.2845 10.3714C12.3127 10.5129 12.3821 10.6428 12.4841 10.7448C12.5861 10.8467 12.716 10.9162 12.8574 10.9443C12.9989 10.9725 13.1455 10.958 13.2787 10.9028C13.412 10.8476 13.5258 10.7542 13.606 10.6343C13.6861 10.5144 13.7288 10.3734 13.7288 10.2292C13.7288 10.0358 13.652 9.85031 13.5153 9.71357C13.3785 9.57682 13.1931 9.5 12.9997 9.5Z",
    fill: "#EDCF30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningsvg);
export default __webpack_public_path__ + "static/media/Warning.svg.01a38b96c69fee7b78603638fa0fe542.svg";
export { ForwardRef as ReactComponent };